<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-mapper" />
      </v-card-title>
    </v-card>
    <div class="mapper-dots">
      <span @click="openAddIDByMapperIndividualDialog('open')">...</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    prnrId: {
      default: '',
    },
    dirCd: {
      default: '',
    },
    comTp: {
      default: 'MAP',
    },
    listSender: {
      default: [],
    },
    listRecipient: {
      default: [],
    },
    mapperContracts: {
      default: '',
    },
    listComId: {
      default: [],
    },
    useSrInMap: {
      default: 0,
    },
    procDirCd: {
      default: '',
    },
    isHistory: {
      default: false,
    },
    manage: {
      default: false,
    },
  },

  computed: {
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
    viewMapVersion() {
      return this.mapVersion;
    },
  },
  data: () => ({
    procIconSize: 24,
    showClose: false,
    mapItem: [],
    mapperId: '',
    mapInfo: {
      mapMsgId: '',
      mapAgency: '',
      mapMsgVer: '',
      mapMsgRel: '',
      mapperName: '',
      scannerName: '',
    },
    hideItem: true,
    hideText: 'Expand',
    isUseDifferentEDI: false,
    listSrm: [],
    indexSrm: 1,
    objSrm: {
      id: '1',
      sender: '',
      recipient: '',
    },
    isCheck: true,
    isEdit: false,
    oldMapId: '',
    count: 0,
    listSenderChange: [],
    listRecipientChange: [],
    listComIdChange: [],
    mapHistory: {},
    mapVersion: '',
    formEmit: {
      comTp: 'MAP',
      comId: '',
      nodeId: '',
    },
  }),
  watch: {
    listSrm: {
      handler: function(val, oldVal) {
        this.openAddIDByMapperIndividualDialog('change');
      },
      deep: true,
    },
    isUseDifferentEDI() {
      let objSrm = {
        id: '1',
        sender: '',
        recipient: '',
        isUseDifferentEDI: Number(this.isUseDifferentEDI),
      };
      if (this.isUseDifferentEDI && !this.isEdit) {
        this.listSrm.push(objSrm);
        let infoEmitMap = {
          mapperId: this.mapperId,
          info: [objSrm],
        };
        EventBus.$emit('set-map-contract', infoEmitMap);
        // 2021.11.11 203728 SPKA-243 add listSrm condition
      } else if (
        this.isUseDifferentEDI &&
        this.isEdit &&
        this.useSrInMap.use_sr_in_map === 0 &&
        this.listSrm.length > 0
      ) {
        this.listSrm[0].isUseDifferentEDI = this.isUseDifferentEDI;
        let infoEmitMap = {
          mapperId: this.mapperId,
          info: this.listSrm,
        };
        EventBus.$emit('set-map-contract', infoEmitMap);
      } else if (!this.isUseDifferentEDI) {
        this.listSrm = [];

        let infoEmitMap = {
          mapperId: this.mapperId,
          info: [objSrm],
        };
        EventBus.$emit('set-map-contract', infoEmitMap);
      }
    },
    isCheck() {
      if (!this.isCheck && this.$vuetify.theme.dark) {
        $('.type-mapper').attr('style', 'color: white !important');
      }
      if (!this.isCheck && !this.$vuetify.theme.dark) {
        $('.type-mapper').attr('style', 'color: #4C4F5A !important');
      }
    },
    listSenderChange() {
      this.listSrm.forEach((element) => {
        element.sender = '';
      });
    },
    listRecipientChange() {
      this.listSrm.forEach((element) => {
        element.recipient = '';
      });
    },
  },
  methods: {
    openAddIDByMapperIndividualDialog(action = 'open') {
      const mapper = {
        isUseDifferentEDI: this.isUseDifferentEDI,
        listSrm: this.listSrm,
        mapperId: this.mapperId,
        nodeId: this.nodeId,
      };
      EventBus.$emit('openAddIDByMapperIndividualDialog', mapper, action);
    },
    resetForm() {
      this.mapInfo = {
        mapMsgId: '',
        mapAgency: '',
        mapMsgVer: '',
        mapMsgRel: '',
        mapperName: '',
        scannerName: '',
      };
      this.mapItem = [];
      this.isUseDifferentEDI = false;
      this.listSrm = [];
      this.indexSrm = 1;
      this.objSrm = {
        id: '1',
        sender: '',
        recipient: '',
      };
      this.isCheck = true;
      this.count = 0;
      this.listSenderChange = [];
      this.listRecipientChange = [];
      this.listComIdChange = [];
      this.mapHistory = {};
      this.mapVersion = '';
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
      let infoEmitMap = {
        oldMapperId: this.mapperId,
        newMapperId: '',
      };
      EventBus.$emit('remove-map-contract', infoEmitMap);
      this.mapperId = '';
      this.oldMapId = '';
      this.count = 0;
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.mapperId = id;
        if (!this.mapperId) {
          this.resetForm();
          // this.selectMap("");
          return;
        }
        this.selectMap(this.mapperId);
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
      });
      this.queryList().then(() => {
        if (this.comId !== '' && this.comId !== undefined) {
          this.mapperId = this.comId;
          let listSender =
            this.listSenderChange.length > 0 ? this.listSenderChange : this.listSender;
          let listRecipient =
            this.listRecipientChange.length > 0 ? this.listRecipientChange : this.listRecipient;
          if (this.useSrInMap.use_sr_in_map === 1) {
            let itemSender, itemRecipient;
            for (let i = 0; i < this.mapperContracts.length; i++) {
              itemSender = listSender.filter(
                (item) => item.id === this.mapperContracts[i].sender_id,
              );
              itemRecipient = listRecipient.filter(
                (item) => item.id === this.mapperContracts[i].receiver_id,
              );
              if (itemSender.length !== 0 && itemRecipient.length !== 0) {
                let objSrm = {
                  id: (i + 1).toString(),
                  sender: {
                    srId: itemSender[0].srId,
                    id: this.mapperContracts[i].sender_id,
                  },
                  recipient: {
                    srId: itemRecipient[0].srId,
                    id: this.mapperContracts[i].receiver_id,
                  },
                  isUseDifferentEDI: this.useSrInMap.use_sr_in_map,
                };
                this.listSrm.push(objSrm);
              } else {
                let objSrm = {
                  id: (i + 1).toString(),
                  sender: { srId: '', id: this.mapperContracts[i].sender_id },
                  recipient: {
                    srId: '',
                    id: this.mapperContracts[i].receiver_id,
                  },
                  isUseDifferentEDI: this.useSrInMap.use_sr_in_map,
                };
                this.listSrm.push(objSrm);
              }
            }
            this.isUseDifferentEDI = true;
            let infoEmitMap = {
              mapperId: this.mapperId,
              info: this.listSrm,
            };
            EventBus.$emit('set-map-contract', infoEmitMap);
          } else {
            let objSrm = {
              id: '1',
              sender: '',
              recipient: '',
              isUseDifferentEDI: this.useSrInMap.use_sr_in_map,
            };
            this.listSrm.push(objSrm);
            let infoEmitMap = {
              mapperId: this.mapperId,
              info: this.listSrm,
            };
            EventBus.$emit('set-map-contract', infoEmitMap);
          }
          this.isEdit = true;
          // 2021.11.1 203728 not check dup id
          this.selectMap('', true);
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
    getIsCheckedOut(itemRow) {
      let isCheckedOut = false;
      this.currentUserId = $cookies.get('user-id');
      this.updateUserId = itemRow.MAP_UPD_USR;
      let isLocked = itemRow.MAP_MAPP_CHKIN_YN === 'Y' ? true : false;
      if (this.currentUserId !== this.updateUserId && isLocked) {
        isCheckedOut = true;
      }
      return isCheckedOut;
    },

    async queryList() {
      console.log('--------- getSummaryList ----------');
      for (let i = 0; i < this.mapList.length; i++) {
        let mapObj = {};
        mapObj.text = this.mapList[i].MAPPINGNAME;
        mapObj.value = this.mapList[i].MAP_PRCS_NO;
        this.mapItem.push(mapObj);
      }
    },
    close() {
      EventBus.$emit('close', this.$el.parentElement.parentElement.id, this.mapperId);
    },
    selectMap(mapperId, refesh = false) {
      let index = this.mapList.findIndex((e) => e.MAP_PRCS_NO == this.mapperId);
      if (index > -1 && (this.manage || this.isHistory)) {
        if (!refesh) {
          //203737 04/20/2021 Check duplicate change select mapper
          let listComId = this.listComIdChange.length > 0 ? this.listComIdChange : this.listComId;
          for (let i = 0; i < listComId.length; i++) {
            const id = 'node-' + listComId[i].nodeId;
            if (listComId[i].comId == mapperId && id !== this.nodeId) {
              this.$nextTick((x) => {
                this.resetForm();
              });
              return;
            }
          }
        }
        // 2021.11.11 203728 SPKA-243 change contract map
        if (this.count > 0) {
          let infoEmitMap = {
            oldMapperId: this.oldMapId,
            newMapperId: mapperId,
          };
          EventBus.$emit('remove-map-contract', infoEmitMap);
        }
        if (this.count === 0) {
          this.oldMapId = this.mapperId;
        } else {
          this.oldMapId = mapperId;
        }
        this.count++;
        // 2021.11.4 203728 SPKA-243 enable check
        this.isCheck = false;
        try {
          for (let i = 0; i < this.mapList.length; i++) {
            if (this.mapList[i].MAP_PRCS_NO === this.mapperId) {
              // alert(JSON.stringify(this.mapList[i]));

              this.mapInfo.mapMsgId = this.mapList[i].MESSAGENAME;
              this.mapInfo.mapAgency =
                this.mapList[i].MESSAGEAGENCY === null ? '' : this.mapList[i].MESSAGEAGENCY;
              this.mapInfo.mapMsgVer = `${
                this.mapList[i].MESSAGEVERSION === null ? '' : this.mapList[i].MESSAGEVERSION
              }`;
              this.mapInfo.mapMsgRel = `${
                this.mapList[i].MESSAGERELEASE === null ? '' : this.mapList[i].MESSAGERELEASE
              }`;
              this.mapInfo.mapperName = `${
                this.mapList[i].MAPPINGNAME === null ? '' : this.mapList[i].MAPPINGNAME
              }`;
              this.mapInfo.scannerName = `${
                this.mapList[i].SCANNERNAME === null ? '' : this.mapList[i].SCANNERNAME
              }`;
              this.mapInfo.mapInfo = `${this.mapInfo.mapAgency}${this.mapInfo.mapMsgVer}${this.mapInfo.mapMsgRel}`;
              this.mapInfo.mapFmt = `${this.mapList[i].MESSAGEFORMAT}`;
              this.mapInfo.mapFmtTo = `${this.mapList[i].MESSAGEFORMATTO}`;
              this.mapVersion = `${this.mapList[i].MAPP_VER}`;
              this.mapHistory = {
                MAPP_VER: `${this.mapList[i].MAPP_VER}`,
                MAPPER_NAME: `${this.mapList[i].MAPPER_NAME}`,
                MAP_PRCS_NO: `${this.mapList[i].MAP_PRCS_NO}`,
                MAP_CONV_TP: `${this.mapList[i].MAP_CONV_TP}`,
                CODE_CTG_ID: `${this.mapList[i].CODE_CTG_ID}`,
                MAP_UPD_USR: `${this.mapList[i].MAP_UPD_USR}`,
                MAP_MAPP_CHKIN_YN: `${this.mapList[i].MAP_MAPP_CHKIN_YN}`,
                HIDE_CHECK_IN: true,
              };

              let isCheckedOut = this.getIsCheckedOut(this.mapHistory);
              this.mapHistory.isCheckedOut = isCheckedOut;

              // this.$emit('set-comp-id', this.mapperId);
              this.formEmit = {
                comId: this.mapperId,
                nodeId: this.nodeId,
                comName: this.mapInfo.mapperName,
                comTp: this.comTp,
              };
              EventBus.$emit('set-comp-id', this.formEmit);
              let infoEmit = {
                info: this.mapList[i],
                nodeId: this.nodeId,
              };
              EventBus.$emit('set-comp-info', infoEmit);
              // this.$emit('set-comp-info', this.mapList[i]);
              if (!this.isEdit) {
                let objSrm = {
                  id: '1',
                  sender: '',
                  recipient: '',
                  isUseDifferentEDI: Number(this.isUseDifferentEDI),
                };
                let infoEmitMap = {
                  mapperId: this.mapperId,
                  info: [objSrm],
                };
                EventBus.$emit('set-map-contract', infoEmitMap);
              }
              break;
            }
          }
        } catch (err) {
          alert(err);
        }
      } else {
        this.resetForm();
      }
    },

    collapse(val) {
      this.hideItem = val;
      this.hideText = this.hideItem ? 'Expand' : 'Collapse';
    },
    focusMap(data) {
      let id = parseInt(this.$el.parentElement.parentElement.id.split('-').pop());
      if (id === data) {
        // this.$refs.selectComId.focus();
      }
    },
    addSrm() {
      for (let i = 0; i < this.listSrm.length; i++) {
        if (this.listSrm[i].sender == '') {
          return;
        } else if (this.listSrm[i].recipient == '') {
          return;
        }
      }
      if (this.listSrm.length < 5) {
        this.indexSrm++;
        let obj = {
          id: this.indexSrm.toString(),
          sender: '',
          recipient: '',
          isUseDifferentEDI: Number(this.isUseDifferentEDI),
        };
        this.listSrm.push(obj);
      }
    },
    removeSrm(itemRemove) {
      if (this.listSrm.length == 1) {
        this.isUseDifferentEDI = false;
      } else {
        this.listSrm = this.listSrm.filter((item) => item.id != itemRemove.id);
      }

      let infoEmit = {
        mapperId: this.mapperId,
        info: this.listSrm,
      };
      EventBus.$emit('set-map-contract', infoEmit);
    },
    selectSender(item) {
      let infoEmit = {
        mapperId: this.mapperId,
        info: this.listSrm,
      };
      EventBus.$emit('set-map-contract', infoEmit);
    },
    selectRecipient(item) {
      let infoEmit = {
        mapperId: this.mapperId,
        info: this.listSrm,
      };
      EventBus.$emit('set-map-contract', infoEmit);
    },
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },
  destroyed() {
    EventBus.$on('focusMap', this.focusMap);
  },
  updated() {
    EventBus.$emit('collapse', {
      nodeId: this.$el.parentElement.parentElement.id,
    });
    this.$emit('collapse');
  },
};
</script>
